// src/pages/ForgotPasswordPage.js
import React from 'react';
import ForgotPassword from '../components/Auth/ForgotPassword';

const ForgotPasswordPage = () => {
  return <ForgotPassword />;
};

export default ForgotPasswordPage;
